import { useBuyerNavigationLayoutContext } from '@/enterprise/components/BuyerNavigationLayout';
import LegacyInvoiceAdjustments from '@/enterprise/features/invoiceAdjustmentTable/LegacyInvoiceAdjustments';
import { AdjustmentsView } from '@/enterprise/features/invoiceTables/adjustments';
import useFeature from '@/lib/features';
import { useReporting } from '@/reporting';

/**
 * Division Details → Adjustments.
 * FF off: Node legacy table. FF on: shared SEA adjustment-invoice view (IC parity)
 * with filter-bar SEA adjustment CSV (all / filtered).
 */
const InvoiceAdjustments = () => {
  const [invoiceApiMigrationEnabled] = useFeature('enterprise-ui_invoiceApiMigration');
  const { trackEnterpriseEvent } = useReporting();
  const { buyer, takerMarket, urlParams } = useBuyerNavigationLayoutContext();

  if (!invoiceApiMigrationEnabled) {
    return <LegacyInvoiceAdjustments />;
  }

  return (
    <AdjustmentsView
      source={{
        makerOrganizationUuid: urlParams.makerOrganizationUuid,
        makerOrganizationName: buyer.makerOrganizationName,
        currency: takerMarket.currency,
        takerMarkets: [takerMarket],
        divisionId: urlParams.takerId,
      }}
      actions={{
        enableFilterBarDownload: true,
        onDownloadSubmitted: ({ scope }) => {
          trackEnterpriseEvent('invoice-download::submitted', {
            invoiceType: 'adjustments',
            downloadScope: scope,
            takerId: urlParams.takerId,
            marketId: urlParams.marketId,
          });
        },
        onSearch: ({ searchValue }) => {
          trackEnterpriseEvent('invoice-search::submitted', { searchValue });
        },
        onSort: ({ sortKey, sortDirection }) => {
          trackEnterpriseEvent('invoice-sort::clicked', { key: sortKey, direction: sortDirection });
        },
        onFiltersChange: ({ filterKeys }) => {
          trackEnterpriseEvent('invoice-filter::clicked', { keys: filterKeys });
        },
        onPageChange: () => {
          trackEnterpriseEvent('invoice-page::clicked');
        },
        onPageSizeChange: ({ size }) => {
          trackEnterpriseEvent('invoice-page-size::clicked', { size });
        },
      }}
    />
  );
};

export default InvoiceAdjustments;
